<template>
  <section class="partners-section">
    <div class="container partners-desktop">
      <a href="https://www.absher.sa/" target="_blank">
        <img
          src="/assets/images/partners/partner1.jpeg"
          loading="lazy"
          alt="Partner 1"
          data-aos="fade-down"
          data-aos-delay="100"
        />
      </a>
      <a href="https://www.musaned.com.sa" target="_blank">
        <img
          src="/assets/images/partners/partner2.jpeg"
          loading="lazy"
          alt="Partner 2"
          data-aos="fade-down"
          data-aos-delay="150"
        />
      </a>
      <a href="https://www.mofa.gov.sa" target="_blank">
        <img
          src="/assets/images/partners/partner3.jpeg"
          loading="lazy"
          alt="Partner 3"
          data-aos="fade-down"
          data-aos-delay="200"
        />
      </a>

      <a href="https://www.moi.gov.sa" target="_blank">
        <img
          src="/assets/images/partners/partner4.jpeg"
          loading="lazy"
          alt="Partner 4"
          data-aos="fade-down"
          data-aos-delay="250"
        />
      </a>
      <a href="https://hrsd.gov.sa" target="_blank">
        <img
          src="/assets/images/partners/partner5.jpeg"
          loading="lazy"
          alt="Partner 5"
          data-aos="fade-down"
          data-aos-delay="300"
        />
      </a>
    </div>

    <div
      class="container swiper-container mobile-partners"
      data-aos="fade-down"
      data-aos-delay="200"
      data-aos-duration="1000"
    >
      <div
        class="swiper-wrapper mobile-partners-wrapper"
        data-aos="fade-down"
        data-aos-delay="200"
      >
        <div class="swiper-slide mobile-partners-slide">
          <a href="https://www.absher.sa/" target="_blank">
            <img src="/assets/images/partners/partner1.jpeg" alt="absher" />
          </a>
        </div>
        <div class="swiper-slide mobile-partners-slide">
          <a href="https://www.musaned.com.sa" target="_blank">
            <img src="/assets/images/partners/partner2.jpeg" alt="musaned" />
          </a>
        </div>
        <div class="swiper-slide mobile-partners-slide">
          <a href="https://www.mofa.gov.sa" target="_blank">
            <img src="/assets/images/partners/partner3.jpeg" alt="Logo 2" />
          </a>
        </div>
        <div class="swiper-slide mobile-partners-slide">
          <a href="https://www.moi.gov.sa" target="_blank">
            <img src="/assets/images/partners/partner4.jpeg" alt="moi" />
          </a>
        </div>
        <div class="swiper-slide mobile-partners-slide">
          <a href="https://hrsd.gov.sa" target="_blank">
            <img src="/assets/images/partners/partner5.jpeg" alt="hrsd" />
          </a>
        </div>
      </div>

      <div class="swiper-button-next mobile-partners-next">
        <i class="fas fa-chevron-left"></i>
      </div>
      <div class="swiper-button-prev mobile-partners-prev">
        <i class="fas fa-chevron-right"></i>
      </div>
    </div>
  </section>
</template>
